import PropTypes from 'prop-types';
import V360 from './V360';
import css from './V360.scss';

V360.displayName = 'V360';

const classes = {
	root: css.v360,
	wrapper: css.v360Wrapper,
	handle: css.v360Handle,
};

V360.propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	fps: PropTypes.number,
	width: PropTypes.number,
	height: PropTypes.number,
	loop: PropTypes.bool,
	drag: PropTypes.bool,
	digits: PropTypes.number,
	startAt: PropTypes.number,
	stepFrames: PropTypes.number,
	texturesPath: PropTypes.string,
	texturesExtensionFiles: PropTypes.string,
	totalTextures: PropTypes.number,
	texturesToLoad: PropTypes.number,
	shouldResetPositionOnChange: PropTypes.bool,
	onLoadStart: PropTypes.func,
	onLoadError: PropTypes.func,
	onLoadProgress: PropTypes.func,
	onLoadComplete: PropTypes.func,
	onRotate: PropTypes.func,
};

V360.defaultProps = {
	className: '',
	classes,
	fps: 24,
	width: 0,
	height: 0,
	loop: true,
	drag: true,
	digits: 2,
	startAt: 0,
	stepFrames: 1,
	texturesPath: '<V360.texturesPath>',
	texturesExtensionFiles: '.jpg',
	totalTextures: 0,
	texturesToLoad: 0,
	onLoadStart: Function.prototype,
	onLoadError: Function.prototype,
	onLoadProgress: Function.prototype,
	onLoadComplete: Function.prototype,
	onRotate: Function.prototype,
	shouldResetPositionOnChange: true,
};

export { V360 };
export default V360;
